import { Application } from "@hotwired/stimulus";

export const application = Application.start();

// Recursively import all controllers except index.ts
const controllers = import.meta.glob("./**/*.ts", { eager: true });

/**
 * Call this function to register Stimulus controllers manually.
 */
export function registerControllers() {
  for (const path in controllers) {
    if (path.endsWith("/index.ts")) continue;

    // e.g. "./users/form.ts" → "users--form"
    const name = path
      .replace("./", "")
      .replace(".ts", "")
      .replace(/\//g, "--") // folders → double-dash
      .replace(/_/g, "-");  // underscores → single dash

    const controllerModule = (controllers as any)[path];
    if (controllerModule?.default) {
      application.register(name, controllerModule.default);
      // console.log(`Registered controller: ${name}`);
    }
  }
}